import { useEffect, useState } from "react";
import axios from "../../api/axios";
import SidebarAdmin from "../../components/SidebarAdmin";

export default function ApiKeys() {
  const [keys, setKeys] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchKeys = async () => {
    try {
      const res = await axios.get("/admin/api-keys");
      setKeys(res.data);
    } catch (err) {
      console.error("Failed to fetch API keys:", err);
    }
    setLoading(false);
  };

  useEffect(() => { fetchKeys(); }, []);

  const handleRevoke = async (userId, email) => {
    if (!window.confirm(`Revoke API key for ${email}? They won't be able to send messages via API.`)) return;
    
    try {
      await axios.delete(`/admin/api-keys/${userId}`);
      fetchKeys();
    } catch (err) {
      alert("Failed to revoke API key");
    }
  };

  const copyKey = (key) => {
    navigator.clipboard.writeText(key);
    alert("API key copied!");
  };

  return (
    <div className="flex flex-col lg:flex-row h-screen bg-gray-50">
      <SidebarAdmin />
      <div className="flex-1 p-4 md:p-6 lg:p-8 overflow-y-auto mt-14 lg:mt-0">
        <div className="mb-6 md:mb-8">
          <h1 className="text-2xl md:text-3xl font-extrabold text-gray-900">API Keys</h1>
          <p className="text-gray-500 mt-1">Manage client API keys for external integrations</p>
        </div>

        {loading ? (
          <div className="flex justify-center py-20">
            <div className="w-10 h-10 border-4 border-blue-500 border-t-transparent rounded-full animate-spin" />
          </div>
        ) : (
          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-x-auto">
            <table className="min-w-[780px] w-full">
              <thead className="bg-gray-900 text-white text-xs uppercase tracking-wider">
                <tr>
                  <th className="p-4 text-left">User</th>
                  <th className="p-4 text-left">API Key</th>
                  <th className="p-4 text-center">Status</th>
                  <th className="p-4 text-center">Actions</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {keys.length === 0 ? (
                  <tr>
                    <td colSpan="4" className="p-8 text-center text-gray-400">
                      No API keys generated yet
                    </td>
                  </tr>
                ) : (
                  keys.map((user) => (
                    <tr key={user.id} className="hover:bg-gray-50 transition">
                      <td className="p-4">
                        <p className="font-bold text-gray-800">{user.name || "N/A"}</p>
                        <p className="text-xs text-gray-400">{user.email}</p>
                      </td>
                      <td className="p-4">
                        <code className="bg-gray-100 px-3 py-1 rounded text-sm font-mono text-gray-600 break-all">
                          {user.api_key.substring(0, 20)}...
                        </code>
                        <button
                          onClick={() => copyKey(user.api_key)}
                          className="ml-2 text-blue-600 hover:text-blue-800 text-sm font-bold"
                        >
                          Copy
                        </button>
                      </td>
                      <td className="p-4 text-center">
                        <span className={`px-3 py-1 rounded-full text-xs font-bold ${
                          user.status === "ACTIVE" 
                            ? "bg-green-100 text-green-700" 
                            : "bg-red-100 text-red-700"
                        }`}>
                          {user.status}
                        </span>
                      </td>
                      <td className="p-4 text-center">
                        <button
                          onClick={() => handleRevoke(user.id, user.email)}
                          className="bg-red-100 text-red-600 px-4 py-2 rounded-lg text-sm font-bold hover:bg-red-200 transition"
                        >
                          Revoke
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        )}

        {/* API Documentation */}
        <div className="mt-8 bg-white p-6 rounded-2xl shadow-sm border border-gray-100">
          <h2 className="text-lg font-bold text-gray-800 mb-4">API Documentation</h2>
          <div className="bg-gray-900 text-gray-300 p-4 rounded-xl text-sm overflow-x-auto">
            <pre>{`# Send Message via API
POST /api/whatsapp/api/send
Headers:
  Content-Type: application/json
  x-api-key: <USER_API_KEY>

Body:
{
  "to": "919876543210",
  "message": "Hello from API!"
}

Response:
{
  "success": true,
  "messageId": 123,
  "whatsappMessageId": "..."
}`}</pre>
          </div>
        </div>
      </div>
    </div>
  );
}
